import script from "./CustomTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTable.vue?vue&type=script&lang=ts&setup=true"

import "./CustomTable.vue?vue&type=style&index=0&id=5d849100&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d849100"]])

export default __exports__